export default __webpack_public_path__ + "static/media/Gwent-YPMod2-ParticipantGuide.3b3ff22d.pdf";